// Type safe window object to prevent SSR errors
export function safeWindow() {
  return typeof window === "undefined" ? null : window
}
